import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchComponent } from "./search.component";
import { FormsModule } from "@angular/forms";
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

@NgModule({
  declarations: [SearchComponent],
  imports: [
    CommonModule,
    BsDropdownModule.forRoot(),
    FormsModule
  ],
  exports: [SearchComponent]
})
export class SearchModule { }
